/**
 * Component <e2-prevent-click />
 *
 * is used to prevent actions while form is parsing the data,
 * prevent redirects and new action while the page is not ready
 *
 * @attr {string} name - The name of the field in the store to check loading state
 *
 * HTML Structure Example
 *
 * <e2-prevent-click store-name="form.isLoading"></e2-prevent-click>
 */

import { SimpleLitElement } from '@elab/components';
import { selectors as uiSelectors } from '@elab/core/store/ui';
import connect from '@elab/core/store/connect';

class PreventClick extends SimpleLitElement {
    static get properties() {
        return {
            overlap: { type: Boolean, reflect: true },
        };
    }

    constructor() {
        super();
        this.overlap = false;
    }
}

const mapStateToProps = state => ({
    overlap: uiSelectors.preventClick(state),
});

export default () =>
    customElements.define('e2-prevent-click', connect(mapStateToProps)(PreventClick));
